import { HealthInfoItem } from 'services/profile/type';
import { isValidExpression } from './utils';

type ParsedHealthInfoItem = HealthInfoItem & {
  eng_choices: unknown;
  spanish_choices: unknown;
};

export const getParsedAnswers = (
  item: HealthInfoItem[]
): ParsedHealthInfoItem[] => {
  const parsedResponse = item?.length
    ? item.map((res) => ({
        ...res,
        eng_choices: isValidExpression(res?.user_eng_choices)
          ? eval(res?.user_eng_choices)
          : res?.user_eng_choices,
        spanish_choices: isValidExpression(res?.user_spanish_choices)
          ? eval(res?.user_spanish_choices)
          : res?.user_spanish_choices,
      }))
    : [];

  return parsedResponse;
};
